<template>
  <BrToolBar @search="buscar" :configFilter="configFilter" :labelTextField="labelTextField">
    <BrModalCadastro />
    <template v-slot:selectTypePagamentos>
      <slot name="btnSelect"/>
    </template>
  </BrToolBar>
</template>

<script>
/**
 * MIXIN
 */
import toolbar from '@/views/mixins/toolbar'

export default {
  name: `BrToolBarCadastroRole`,
  mixins: [toolbar],
  components: { 
    BrModalCadastro: () => import('@/views/components/modalDadosUsuario'),
    BrToolBar: () => import('@/views/components/toolbar')
  }
}
</script>